import { Reveal } from "./Reveal";
import { Mail, Phone, MapPin } from "lucide-react";

const ITEMS = [
  { icon: Mail, label: "Email", value: "John@johncampbellinsurance.com", href: "mailto:John@johncampbellinsurance.com" },
  { icon: Phone, label: "Phone", value: "623-414-1766", href: "tel:+16234141766" },
  { icon: MapPin, label: "Consultations", value: "By Appointment — Arizona and Select States", href: "#quote" },
];

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="relative bg-[#0a0a0a] py-16 lg:py-20 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-[1fr_1fr] gap-16 items-end">
          <Reveal>
            <span className="mono text-[10px] uppercase tracking-[0.35em] text-[#d4af37] block mb-4">Contact</span>
            <h2 className="serif font-light leading-[1.02] text-[#f4f0ea] text-4xl sm:text-5xl lg:text-6xl">
              Speak with a<br /><span className="italic text-[#d4af37]">real advisor</span>.
            </h2>
          </Reveal>

          <div className="space-y-2">
            {ITEMS.map((it, i) => {
              const Icon = it.icon;
              return (
                <Reveal key={it.label} delay={i * 0.08}>
                  <a
                    href={it.href}
                    data-testid={`contact-${it.label.toLowerCase()}`}
                    className="group flex items-center justify-between py-6 border-t border-white/10 hover:border-[#d4af37]/40 transition-colors duration-400"
                  >
                    <div className="flex items-center gap-5">
                      <Icon size={20} className="text-[#d4af37]" />
                      <div>
                        <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#737373] mb-1">{it.label}</div>
                        <div className="text-lg text-[#f4f0ea] group-hover:text-[#d4af37] transition-colors">{it.value}</div>
                      </div>
                    </div>
                    <span className="text-[#737373] group-hover:text-[#d4af37] group-hover:translate-x-1 transition-all duration-400">→</span>
                  </a>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
